import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../services/api';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await api.post('/auth/login', { email, password });
      login(data.token, data.user);
      navigate('/admin');
    } catch (e) { setError(e.message); }
  };

  return (
    <div className="neon-admin-login">
      <form onSubmit={handleSubmit} className="neon-login-box">
        <h2>🔐 Admin NEON</h2>
        {error && <p className="neon-error">{error}</p>}
        <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="Contraseña" value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" className="neon-btn neon-btn-primary">Entrar</button>
      </form>
    </div>
  );
}
